import type { RechartData } from '../../shared/utils/chartModel'

/**
 * Calculates the sum of the sum object inside rechartData for all available traces
 * If getPositiveOnly is true, only positive values are considered
 */
export const getRechartDataSumValue = (rechartData: RechartData): number => {
  if (!rechartData?.sums) return 0

  const historyValues = Object.values(rechartData.sums).map(sum => sum.history ?? 0)

  return historyValues.reduce((total, current) => total + current, 0)
}
